import {
  APP_MANAGED_ROUTES,
  BackgroundInformationModal,
  CONTENT_ROUTES,
  FEATURE_FLAGS,
  FeatureFlagConditionalPage,
  HsaPage,
  LegalPage,
  MODAL_PARAMS,
  PageBlockerContainer,
  PWPRoutes,
  QUERY_PARAM_KEYS,
  EnhancedBenefitsPage,
  CaseManagementPage,
} from '@highmark-web/highmark-common';
import { Navigate, RouteObject } from 'react-router-dom';
import {
  HomePage,
  SupportPage,
  AnnualAuthorizationsPage,
} from 'components/lazy-routes.component';
import openHsaImage from 'assets/hsa/open-hsa.svg';
import hsaAccountCreatedImage from 'assets/hsa/hsa-account-created.svg';
import { getModulePath, LEAGUE_MODULE_NAMES } from '@leagueplatform/core';
import { AboutIel } from 'pages/settings/about-iel.page';
import { useGetAppFeatureFlag } from 'hooks/use-get-app-feature-flag.hook';

export const StandaloneRoutes: RouteObject[] = [
  {
    path: `${APP_MANAGED_ROUTES.BACKGROUND_INFORMATION}/*`,
    element: <BackgroundInformationModal />,
  },
  {
    path: APP_MANAGED_ROUTES.HOME,
    element: <HomePage />,
  },
  {
    path: APP_MANAGED_ROUTES.HSA_ENROLLMENT,
    element: (
      <HsaPage
        openHsaImage={openHsaImage}
        hsaAccountCreatedImage={hsaAccountCreatedImage}
      />
    ),
  },
  { path: `${APP_MANAGED_ROUTES.ABOUT}/*`, element: <AboutIel /> },
  { path: `${APP_MANAGED_ROUTES.LEGAL}/*`, element: <LegalPage /> },
  {
    path: APP_MANAGED_ROUTES.EBILL,
    element: (
      <Navigate
        to={`${APP_MANAGED_ROUTES.HOME}?${QUERY_PARAM_KEYS.modal}=${MODAL_PARAMS.EBILL_REGISTRATION}`}
        replace
      />
    ),
  },
  {
    path: APP_MANAGED_ROUTES.SUPPORT,
    element: <SupportPage />,
  },
  {
    path: APP_MANAGED_ROUTES.ANNUAL_AUTHORIZATIONS,
    element: <AnnualAuthorizationsPage />,
  },
  {
    path: `${getModulePath(LEAGUE_MODULE_NAMES.healthJourney)}${APP_MANAGED_ROUTES.PWP_SUBPATH}/*`,
    element: (
      <FeatureFlagConditionalPage
        useGetAppFeatureFlag={useGetAppFeatureFlag}
        flagName={FEATURE_FLAGS.PWP}
      >
        <PageBlockerContainer contentRoute={CONTENT_ROUTES.JOURNEY}>
          <PWPRoutes />
        </PageBlockerContainer>
      </FeatureFlagConditionalPage>
    ),
  },
  {
    path: APP_MANAGED_ROUTES.ENHANCED_BENEFITS,
    element: <EnhancedBenefitsPage />,
  },
  {
    path: APP_MANAGED_ROUTES.CASE_MANAGEMENT_PROGRAM,
    element: <CaseManagementPage />,
  },
];
